import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MapTableService } from '@ebw-monorepo/map';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { Observable, Subject, takeUntil, tap } from 'rxjs';
import { IMapTable } from '../../../../interfaces/mapTable.interface';
import { CavoRaccordo } from '../../../../models/cavo-raccordo.model';
import { RaccordiCavoTableComponent } from '../raccordi-cavo-table/raccordi-cavo-table.component';

@Component({
  selector: 'ebw-monorepo-raccordi-cavo-home',
  templateUrl: './raccordi-cavo-home.component.html',
  styleUrls: ['./raccordi-cavo-home.component.scss']
})
export class RaccordiCavoHomeComponent implements OnInit, OnDestroy {
  public raccordoCavoConfig$: Observable<IMapTable>;
  public selectedRaccordo: CavoRaccordo;
  public fibraConfig: IMapTable;
  public detailRequested = false;
  @ViewChild('cavoTable', { static: true }) cavoTable!: RaccordiCavoTableComponent;

  private _destroy$ = new Subject<void>();

  // ------------------------------------------------------------------------------------------------

  constructor(private mapTableSrv: MapTableService, private _apiUrlService: ApiUrlService) {}

  // ------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.raccordoCavoConfig$ = this.mapTableSrv.getMapTableConfig().pipe(
      tap(() => {
        this.closeFiberTable();
        this._resetRaccordoCavoTable();
      }),
      takeUntil(this._destroy$)
    );
  }

  // ------------------------------------------------------------------------------------------------

  ngOnDestroy(): void {
    this._destroy$.next();
    this._closeMapTable();
  }

  // ------------------------------------------------------------------------------------------------

  onFiberDetailRequested(raccordo: CavoRaccordo) {
    this.fibraConfig = null;
    this.fibraConfig = {
      url: this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.FIBER.LIST),
      title: 'map.sidebar.fibra.table.title',
      filters: {
        id_raccordo: raccordo.id
      }
    };

    this.detailRequested = true;
    this.selectedRaccordo = raccordo;
  }

  // ------------------------------------------------------------------------------------------------

  onReloadFiberRequested() {
    if (this.detailRequested && this.selectedRaccordo) {
      this.onFiberDetailRequested(this.selectedRaccordo);
    }
  }

  // ------------------------------------------------------------------------------------------------

  /**
   * Se il cavo che è stato eliminato corrisponde a quello a cui appartengono le fibre mostrate in tabella,
   * chiude la tabella poichè non sarà più possibile consultarle
   * @returns {void}
   */
  checkEliminazioneCavo({ id }: { id: number }): void {
    const deleteCavoEqualToSelectedCavo = this.selectedRaccordo?.id == id;

    if (!deleteCavoEqualToSelectedCavo) {
      return;
    }
    this.closeFiberTable();
  }

  // ------------------------------------------------------------------------------------------------

  onDblCLick() {
    this.closeFiberTable();
    this._resetRaccordoCavoTable();
  }

  // ------------------------------------------------------------------------------------------------

  private _resetRaccordoCavoTable() {
    if (this.cavoTable) {
      this.cavoTable.resetHightlightedItem();
    }
  }

  // ------------------------------------------------------------------------------------------------

  private _closeMapTable() {
    this.mapTableSrv.setMapTableConfig(null);
  }

  // ------------------------------------------------------------------------------------------------

  private closeFiberTable() {
    this.detailRequested = false;
    this.selectedRaccordo = null;
  }

  // ------------------------------------------------------------------------------------------------
  /**
   * Metodo scatenato quando ebw-monorepo-fiber-table emette fetchDataEventEmitter
   * Serve per aggiornare i dati dei cavi nel caso in cui venga modificato lo stato di una fibra (cambia p.iru)
   */
  fetchDataTableTrigger(): void {
    // Verifichiamo che il componente esista (buona pratica per evitare errori safe-navigation)
    if (this.cavoTable) {
      this.cavoTable.fetchData();
    }
  }
}
